module.exports = __webpack_public_path__ + "img/avatar_26.dd784754.svg";